"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionListToFirmwareUpdateMethod = exports.unionToFirmwareUpdateMethod = exports.FirmwareUpdateMethod = void 0;
const otafirmware_update_js_1 = require("../../solarxr-protocol/rpc/otafirmware-update.js");
const serial_firmware_update_js_1 = require("../../solarxr-protocol/rpc/serial-firmware-update.js");
var FirmwareUpdateMethod;
(function (FirmwareUpdateMethod) {
    FirmwareUpdateMethod[FirmwareUpdateMethod["NONE"] = 0] = "NONE";
    FirmwareUpdateMethod[FirmwareUpdateMethod["OTAFirmwareUpdate"] = 1] = "OTAFirmwareUpdate";
    FirmwareUpdateMethod[FirmwareUpdateMethod["SerialFirmwareUpdate"] = 2] = "SerialFirmwareUpdate";
})(FirmwareUpdateMethod = exports.FirmwareUpdateMethod || (exports.FirmwareUpdateMethod = {}));
function unionToFirmwareUpdateMethod(type, accessor) {
    switch (FirmwareUpdateMethod[type]) {
        case 'NONE': return null;
        case 'OTAFirmwareUpdate': return accessor(new otafirmware_update_js_1.OTAFirmwareUpdate());
        case 'SerialFirmwareUpdate': return accessor(new serial_firmware_update_js_1.SerialFirmwareUpdate());
        default: return null;
    }
}
exports.unionToFirmwareUpdateMethod = unionToFirmwareUpdateMethod;
function unionListToFirmwareUpdateMethod(type, accessor, index) {
    switch (FirmwareUpdateMethod[type]) {
        case 'NONE': return null;
        case 'OTAFirmwareUpdate': return accessor(index, new otafirmware_update_js_1.OTAFirmwareUpdate());
        case 'SerialFirmwareUpdate': return accessor(index, new serial_firmware_update_js_1.SerialFirmwareUpdate());
        default: return null;
    }
}
exports.unionListToFirmwareUpdateMethod = unionListToFirmwareUpdateMethod;
